import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

/**
 * Role-gated route wrapper for the Employer Hub.
 * Unauthenticated → /login. Authenticated applicant → applicant dashboard.
 */
export const EmployerProtectedRoute = ({ children }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-white"
        data-testid="hub-auth-loading"
      >
        <div className="h-8 w-8 rounded-full border-2 border-blue-600 border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (user?.account_type !== "employer") {
    return <Navigate to="/dashboard/applicant" replace />;
  }
  return children;
};
